<template>
  <div>
      <div class="form-group">        
        <label for="product">Product (exampe: @item/stock/m3star)</label>
        <!-- TODO: No element with id product. Click on lable do nothig. Fix it. -->

        <vue-bootstrap-typeahead
          v-model="productAlias"
          :data="suggestions"
          :minMatchingChars="1"
          required
        />
      </div>

      <div class="form-group">
        <label for="amount">Amount</label>
        <input v-model="amount" id="amount" class="form-control" type="number" min="1" required>
      </div>

      <div class="form-group">
        <label for="letter">
          Letter (optional)<br>
          Alias of prototype ConfPending.<br>
          Example: @pendings/for_vip
        </label>
        <input v-model="letter" id="letter" class="form-control">
      </div>
  </div>
</template>

<script>
import notifier from '../notifier';
import { HTTP } from '../http-common';
import VueBootstrapTypeahead from './VueBootstrapTypeahead.vue';

export default {
  name: 'PlayerPendingAddDataInputRewardForVip',

  components: {
    VueBootstrapTypeahead,
  },

  data() {
    return {
      productAlias: '',
      amount: 1,
      suggestions: [],

      letter: '',
    };
  },

  watch: {
    productAlias(newProductAlias) {
      // TODO: delete
      //this.suggestions = protoManager.getSuggestions(newProductAlias);

      HTTP.get(
        '/proto_item_aliases/find',
        {
          params: {
            q: newProductAlias
          }
        }
      )
      .then(response => {
        const aliases = [];
        for(var i = 0; i < response.data.data.length; ++i) {
          const alias = response.data.data[i];
          aliases.push(alias);
        }
        this.suggestions = aliases;
      })
      .catch(e => {
        notifier.showError(e.response.data);
      })
    },
  },

  methods: {
    fillFormData(formData) {
      formData.append('product', this.productAlias);
      formData.append('amount', this.amount);

      const trimmedLetter = this.letter.trim();
      if(trimmedLetter.length > 0) {
        formData.append('letter', trimmedLetter);
      }

      return null;
    },
  },
}
</script>